import {
    CHANGE_CULTURE,
    ACCEPT_AGREEMENT_REQUEST,
    ACCEPT_AGREEMENT_SUCCESS,
    ACCEPT_AGREEMENT_ERROR,
    CHECK_AGREEMENT_REQUEST,
    CHECK_AGREEMENT_SUCCESS,
    CHECK_AGREEMENT_ERROR,
    SET_LANGUAGE_CONTEXT,
    SET_LOGIN_LANGUAGE_PROMPT,
    CLEAR_LOGIN_LANGUAGE_PROMPT
} from "../actions/general";

const general = (state = {}, action) => {
    switch (action.type) {
        case CHANGE_CULTURE:
            return {
                ...state,
                culture: action.culture
            };
        case ACCEPT_AGREEMENT_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case ACCEPT_AGREEMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                showGdprAgreement: false
            };
        case ACCEPT_AGREEMENT_ERROR:
            return {
                ...state,
                fetching: false
            };
        case CHECK_AGREEMENT_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case CHECK_AGREEMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                showGdprAgreement: action.showGdprAgreement
            };
        case CHECK_AGREEMENT_ERROR:
            return {
                ...state,
                fetching: false
            };
        case SET_LANGUAGE_CONTEXT:
            return { ...state, savedCulture: action.savedCulture, resolvedCulture: action.resolvedCulture };
        case SET_LOGIN_LANGUAGE_PROMPT:
            return { ...state, loginLanguagePrompt: action.prompt };
        case CLEAR_LOGIN_LANGUAGE_PROMPT:
            return { ...state, loginLanguagePrompt: null };
        default:
            return state;
    }
}

export default general;